import { render } from "./SimpleLayout.vue?vue&type=template&id=572fabb8"
import script from "./SimpleLayout.vue?vue&type=script&lang=js"
export * from "./SimpleLayout.vue?vue&type=script&lang=js"

import "./SimpleLayout.vue?vue&type=style&index=0&id=572fabb8&lang=css"
script.render = render

export default script